<template>
    <div class="conf-con">
                            <div class="intro-pic">
                              <img src="../../../assets/images/06.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第六次全国代表大会简介</p>
                            <p class="margin1">1927年大革命失败后，中国共产党开始走上了独立领导中国革命的道路。在关于中国社会性质以及革命性质、对象、动力、前途等关系革命成败的重大问题上，迫切需要召开一次党的全国代表大会认真加以解决。由于国内当时正处在极为严重的白色恐怖中，很难找到一个安全的开会地点，加上1928年春夏间将相继在莫斯科召开赤色职工第四次大会、共产国际第六次大会和少共国际第五次大会，考虑到届时中国共产党都将派代表出席这几个大会，而且中共中央也迫切希望能够得到共产国际的及时指导，遂决定党的六大在莫斯科召开。</p>
                            <p class="margin1">1928年3月，共产国际来电同意中共六大在苏联境内召开。4月2日，中共中央临时政治局常委会开会研究召开六大的问题，决定李维汉、任弼时留守，负责中央日常工作，邓小平为留守中央秘书长。1928年4月下旬起，瞿秋白、周恩来等中央领导人和100多位参加六大的代表相继分批秘密前往莫斯科。</p>
                            <p class="margin1">1928年6月18日至7月11日，中国共产党第六次全国代表大会在莫斯科近郊兹维尼果罗德镇“银色别墅”秘密召开。出席大会的代表共142人，其中有表决权的正式代表为84人。 </p>
                            <p class="margin1">瞿秋白代表第五届中央委员会作《中国革命与共产党》的政治报告，周恩来作了组织报告和军事报告，李立三作农民问题报告，向忠发作了职工运动报告，共产国际代表布哈林作了《中国革命与中国共产党的任务》的报告。大会通过了关于政治、军事、组织、苏维埃政权、农民、土地、职工、宣传、民族、妇女、青年团等问题的决议，以及经过修改的《中国共产党党章》。</p>
                            <p class="margin1">六大选举产生了新的中央委员会：中央委员23人，候补中央委员13人。随后召开的六届一中全会选举苏兆征、项英、周恩来、向忠发、瞿秋白、蔡和森、张国焘为中央政治局委员，关向应、李立三、罗登贤、彭湃、杨殷、卢福坦、徐锡根为政治局候补委员；选举苏兆征、向忠发、项英、周恩来、蔡和森为中央政治局常委会委员，李立三、杨殷、徐锡根为常委会候补委员。六届中央政治局第一次会议选举向忠发为中央政治局主席兼中央政治局常委会主席，周恩来为中央政治局常委会秘书长。</p>
                            <p class="margin1">党的六大是在特定历史时期和历史条件下召开的具有重大历史意义的会议。六大认真地总结了大革命失败以来的经验教训，对有关中国革命的一系列存在严重争论的根本问题，作出了基本正确的回答。它集中解决了当时困扰党的两大问题：一是在中国社会性质和革命性质问题上，指出现阶段的中国仍是半殖民地半封建社会，引起中国革命的基本矛盾一个也没有解决，现阶段的中国革命依然是资产阶级性质的民主主义革命。二是在革命形势和党的任务问题上，明确了革命处于低潮，党的总路线是争取群众，党的中心工作不是千方百计地组织暴动，而是做艰苦的群众工作，积蓄力量。这两个重要问题的解决，基本上统一了全党思想，对克服党内存在的“左”倾情绪，实现工作的转变，起了积极的作用。</p>
                            <p class="margin1">由于历史发展的局限性，党的六大对中国革命的特点、中国革命的中心问题、中国革命的敌人、党的工作重心等问题认识不足，但这仍然不能掩盖党的六大本身主要方面和路线的正确性。 </p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>